import { render, staticRenderFns } from "./SubFuseButton.vue?vue&type=template&id=4857b1b5&lang=pug&"
import script from "./SubFuseButton.vue?vue&type=script&lang=ts&"
export * from "./SubFuseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports